/**
 * Copyright © 2020 Redbox Digital Limited. All rights reserved.
 */
define('Magento_Theme/js/sticky-header',[
    'jquery',
    'matchMedia',
    'domReady!',
], function ($, mediaCheck) {
    'use strict';
    return function (config, el) {

        var globalOptions = {
            mediaBreakpoint: '(max-width: 1008px)',
            headerHeight: 0,
            scrollPosition: 0,
            lastScrollPosition: 0,
            windowWidth: 0,
            isIosDevice: false
        };

        var rbd = rbd || {};
        rbd.stickyHeader = {
            options: globalOptions,

            /**
             * Initialisation
             */
            init: function () {
                var _self = this;

                mediaCheck({
                    media: _self.options.mediaBreakpoint,
                    entry: $.proxy(function () {
                        _self.options.headerHeight = _self._getHeaderHeight('mobile');
                        _self.options.windowWidth = $(window).width();
                    }, this),
                    exit: $.proxy(function () {
                        _self.options.headerHeight = _self._getHeaderHeight('desktop');
                        _self.options.windowWidth = $(window).width();
                    }, this)
                });

                this._deviceDetect();
                this._setHeaderSticky(this.options.headerHeight);
                this._screenResizeFixer();
            },

            /**
             * Set '_stickyheader' css class on the main action bar container
             * @param hh
             * @private
             */
            _setHeaderSticky: function (hh) {
                var _self = this;
                if (hh > 0) {
                    $(window).on('scroll', function () {
                        var headerContainer = $('.page-header'),
                            actionBarContainer = $('.action-bar'),
                            actionBarContainerHeight = actionBarContainer.length ? actionBarContainer.height() : 0,
                            loginStripContainer = $('.login-strip__container.login-strip__sticky.login-strip__sticky--top'),
                            navSection = $('.nav-sections .nav-sections-items').outerHeight(true),
                            pageTopContainerHeight = $('.page-top-strip__sticky').length ? $('.page-top-strip__container').outerHeight(true) : 0;

                        _self.options.headerHeight = _self._getHeaderHeight('desktop') + pageTopContainerHeight;
                        _self.options.scrollPosition = $(document).scrollTop();

                        if(_self.options.scrollPosition < _self.options.lastScrollPosition && _self.options.scrollPosition > _self.options.headerHeight) {
                            headerContainer.parent().addClass('_stickyheader');
                            if (_self.options.windowWidth > 1008) {
                                actionBarContainer.css('top', _self.options.headerHeight);
                                loginStripContainer.css('top', actionBarContainerHeight + _self.options.headerHeight);
                                $('body').css('padding-top', _self.options.headerHeight + actionBarContainer.outerHeight(true));
                            } else if (_self.options.windowWidth < 1009 && _self.options.isIosDevice) {
                                actionBarContainer.css('top', _self.options.headerHeight);
                                loginStripContainer.css('top', actionBarContainerHeight + _self.options.headerHeight);
                                $('body').css('padding-top', '');
                            } else {
                                actionBarContainer.css('top', _self.options.headerHeight);
                                loginStripContainer.css('top', actionBarContainerHeight + _self.options.headerHeight);
                                $('body').css('padding-top', _self.options.headerHeight + actionBarContainer.outerHeight(true));
                            }

                        } else {
                            headerContainer.parent().removeClass('_stickyheader');
                            headerContainer.css('top', pageTopContainerHeight);
                            loginStripContainer.css('top', actionBarContainerHeight + pageTopContainerHeight);
                            actionBarContainer.css('top', pageTopContainerHeight);
                            $('body').css('padding-top','');
                        }

                        _self.options.lastScrollPosition = _self.options.scrollPosition;
                    });
                }
            },

            /**
             * Set header height on each screen resize event
             * @private
             */
            _screenResizeFixer: function () {
                var _self = this;
                $(window).on('resize', function () {
                    if ($(window).width() > 1008) {
                        _self.options.headerHeight = _self._getHeaderHeight('desktop');
                        _self.options.windowWidth = $(window).width();
                    } else {
                        _self.options.headerHeight = _self._getHeaderHeight('mobile');
                        _self.options.windowWidth = $(window).width();
                    }
                });
            },

            /**
             * Returns height of the header elements
             * @param screen
             * @return {number|*}
             * @private
             */
            _getHeaderHeight: function (screen) {
                var hh = 0;
                if (screen === 'desktop') {
                    hh = $('.page-header').outerHeight(true);
                } else {
                    hh = $('.page-header').outerHeight(true);
                }
                return hh;
            },

            /**
             * Detect Device
             */
            _deviceDetect: function () {
                let _self = this;
                let userAgent = navigator.userAgent;

                _self.options.isIosDevice = /iPad|iPhone/.test(userAgent);
            }

        }
        rbd.stickyHeader.init();
    }
});

